import { z } from 'zod/v3';

// Invitation DTOs
export const InvitationDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  organization: z.string(),
  email: z.string(),
  role: z.string().optional(),
  status: z.string(),
  expiresAt: z.date(),
  inviterId: z.string(),
  user: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const InvitationListDTOSchema = z.object({
  id: z.string(),
  status: z.string(),
  createdAt: z.date(),
  updatedAt: z.date()
}).strict();

export const CreateInvitationDTOSchema = z.object({
  organizationId: z.string(),
  organization: z.string(),
  email: z.string(),
  role: z.string().optional(),
  status: z.string(),
  expiresAt: z.date(),
  inviterId: z.string(),
  user: z.string()
}).strict();

export const UpdateInvitationDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string().optional(),
  organization: z.string().optional(),
  email: z.string().optional(),
  role: z.string().optional(),
  status: z.string().optional(),
  expiresAt: z.date().optional(),
  inviterId: z.string().optional(),
  user: z.string().optional()
}).strict();

export type InvitationDTO = z.infer<typeof InvitationDTOSchema>;
export type InvitationListDTO = z.infer<typeof InvitationListDTOSchema>;
export type CreateInvitationDTO = z.infer<typeof CreateInvitationDTOSchema>;
export type UpdateInvitationDTO = z.infer<typeof UpdateInvitationDTOSchema>;
